<div class="settings-wrapper maps-settings-warpper">
  <div class="settings-container">
    <div class="settings-header" *ngIf="!isMobileView">
      <h2>{{ settings }}</h2>
    </div>

    <form *ngIf="settingsForm" [formGroup]="settingsForm" class="settings-form">
      <div class="settings-group">
        <mat-label>{{ translated[translations.settings.speedSettingDescription] }}</mat-label>
      </div>
      <div class="settings-group">
        <mat-checkbox labelPosition="before" formControlName="showVehicleSpeed" class="settings-speed-checkbox">{{
          translated[translations.settings.speedDisplay] }}</mat-checkbox>
      </div>
      <div class="settings-group">
        <mat-label>{{ translated[translations.settings.distanceUnitSelection] }}</mat-label>
        <div class="settings-unit" fxLayout="row" fxLayoutAlign="start center" fxLayout.lt-md="column">
          <div class="mr-1">
            <mat-label>{{ translated[translations.settings.distanceUnit] }}</mat-label>
            <mat-form-field appearance="outline" class="settings-form-field">
              <mat-select formControlName="distanceUnit">
                <mat-option *ngFor="let option of distanceUnitOpts" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-label>{{ translated[translations.settings.speedUnit] }}</mat-label>
            <mat-form-field appearance="outline" class="settings-form-field">
              <mat-select formControlName="speedUnit">
                <mat-option *ngFor="let option of speedUnitOpts" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="settings-group" fxLayout="row" fxLayoutAlign="start baseline" fxLayout.lt-md="column">
        <mat-label>{{ translated[translations.settings.dateformatSeletion] }}</mat-label>
        <mat-form-field appearance="outline" class="settings-form-field date-format-field">
          <mat-select formControlName="dateFormat">
            <mat-option *ngFor="let option of dateFormatOpts" [value]="option.value">
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="settings-group">
        <mat-label>{{ translated[translations.settings.displayVehicleNameSelection] }}</mat-label>
      </div>
      <div class="settings-group">
        <mat-label>{{ translated[translations.settings.nameDisplay] }}</mat-label>
        <mat-form-field appearance="outline" class="settings-form-field">
          <mat-select formControlName="assetViewType">
            <mat-option *ngFor="let option of assetViewOptions" [value]="option.value">
              {{ option.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="settings-group" *ngIf="!isMobileView">
        <mat-label><span class="beta-feature">{{ translated[translations.settings.beataFeature] }} : </span>{{
          translated[translations.settings.driverActivities] }}</mat-label>
        <div class="my-1">
          <mat-checkbox labelPosition="before" formControlName="elapsedTime" class="settings-speed-checkbox">{{
            translated[translations.settings.elapsedTime] }}</mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</div>